import { api } from 'src/api/axios';
import { InsuranceProvider, InsurancePlan } from './interfaces/insurance';

export const insuranceService = {
  getProviders: async (): Promise<InsuranceProvider[]> => {
    const response = await api.get<InsuranceProvider[]>('/insurances/providers');
    return response.data;
  },

  createProvider: async (data: InsuranceProvider): Promise<InsuranceProvider> => {
    const response = await api.post<InsuranceProvider>('/insurances/providers', data);
    return response.data;
  },

  getProvider: async (id: string): Promise<InsuranceProvider> => {
    const response = await api.get<InsuranceProvider>(`/insurances/providers/${id}`);
    return response.data;
  },

  updateProvider: async (id: string, data: InsuranceProvider): Promise<InsuranceProvider> => {
    const response = await api.patch<InsuranceProvider>(`/insurances/providers/${id}`, data);
    return response.data;
  },

  deleteProvider: async (id: string): Promise<void> => {
    await api.delete(`/insurances/providers/${id}`);
  },

  getPlans: async (): Promise<InsurancePlan[]> => {
    const response = await api.get<InsurancePlan[]>('/insurances/plans');
    return response.data;
  },

  getFullPlans: async (): Promise<InsurancePlan[]> => {
    const response = await api.get<InsurancePlan[]>('/insurances/plans/full');
    return response.data;
  },

  createPlan: async (data: InsurancePlan): Promise<InsurancePlan> => {
    const response = await api.post<InsurancePlan>('/insurances/plans', data);
    return response.data;
  },

  getPlan: async (id: string): Promise<InsurancePlan> => {
    const response = await api.get<InsurancePlan>(`/insurances/plans/${id}`);
    return response.data;
  },

  updatePlan: async (id: string, data: InsurancePlan): Promise<InsurancePlan> => {
    const response = await api.patch<InsurancePlan>(`/insurances/plans/${id}`, data);
    return response.data;
  },

  deletePlan: async (id: string): Promise<void> => {
    await api.delete(`/insurances/plans/${id}`);
  },
};